export enum TaskPriority {
    Low = 'low',
    Medium = 'medium',
    High = 'high'
}
